module.exports = __webpack_public_path__ + "static/media/30-3.f1adc304.mp3";